import React, { useCallback, useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import search from "../images/search.svg";
import download from "../images/searchBarDownload.svg";
import filter from "../images/filter.svg";
import axios from "axios";
import { KeyboardArrowDown } from "@mui/icons-material";
import { decryptText } from "../utils/cipherText";
import GreenButton from "./GreenButton";
import { GoDownload } from "react-icons/go";
import { LuFilter } from "react-icons/lu";
import { CiSearch } from "react-icons/ci";
import FinsireButton from "./FinsireButton";
import { FiFilter } from "react-icons/fi";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { MdOutlineCancel } from "react-icons/md";
import { TbColumns3 } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { updateIndividualSearch } from "../redux/slices/SearchSlice";

const IndividualsTopBar = ({
  downloadPageWord,
  filterShow,
  setSearchQuery,
  filterList,
  setFilterShow,
  selectedFilter,
  setSelectedFilter,
  searchQuery,
  inputref,
  showButton,
  openAdvancedFilter,
  setOpenAdvancedFilter,
  advancedOptionSelected,
  setAdvancedOptionSelected,
  advancedStartDate,
  setAdvancedStartDate,
  advancedEndDate,
  setAdvancedEndDate,
  fetchAdvancedFilters,
  clearAdvancedFilters,
  advancedSelectValue,
  setAdvancedSelectValue,
  advancedEnterValue,
  setAdvancedEnterValue,
  tempVisibility,
  setTempVisibility,
  setVisibleColumns,
  loanType,
  setLoanType,
  leafColumns,
  columnSettings,
  setColumnSettings,
  setUserStepFilter,
}) => {
  const dispatch = useDispatch();
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [filterApplied, setFilterApplied] = useState(false);
  const handlePageDownload = async () => {
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/download_${
          // (downloadPageWord === "transactions" && "transaction") ||
          // (downloadPageWord === "distributors" && "distributor") ||
          // "selected"
          downloadPageWord
        }_csv?page_name=${downloadPageWord}`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res.data.download_url);

      const link = document.createElement("a");
      link.href = res.data.download_url;
      link.download = "data.csv";
      link.textContent = "Download CSV";
      // Append the link to the DOM and trigger the download
      document.body.appendChild(link);
      link.click();
      // Clean up the object URL
      URL.revokeObjectURL(link.href);
      // Remove the link from the DOM
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };

  const options = [
    { value: "loan_type", label: "Loan Type" },
    { value: "user_step", label: "Current Step" },
    { value: "last_login_date", label: "Last Online" },
    { value: "newest_loan_creation", label: "Loan creation date" },
    { value: "total_asset_value", label: "Total Holdings" },
  ];

  const toggleTempVisibility = (columnId) => {
    setTempVisibility((prev) => {
      // Directly toggle the specific column's visibility
      return {
        ...prev,
        [columnId]: !(prev[columnId] ?? true), // Default to true if undefined
      };
    });
  };
  function convertToTitle(text) {
    return text
      .split("_") // Split the string into an array using underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the array back into a string with spaces
  }

  const filterDropdownRef = useRef(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedFlag, setSelectedFlag] = useState("");
  const [selectedValueFlag, setSelectedValueFlag] = useState("");
  const divRef = useRef(null);
  const selectref = useRef(null);
  const divRefColumn = useRef(null);
  const selectrefColumn = useRef(null);
  const [loanTypeReference, setLoanTypeReference] = useState(null);
  const [userStepReferrence, setUserStepReferrence] = useState(null);

  const clearFilters = () => {
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setSelectedFlag("");
    setSelectedValueFlag("");
    setFilterApplied(false);
    setLoanTypeReference("");
    setUserStepFilter("");
    setUserStepReferrence("");
  };

  const handleStartDateChange = (date) => {
    const dateFormat = new Date(date);
    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    setAdvancedStartDate(ans);
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    const dateFormat = new Date(date);
    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    setAdvancedEndDate(ans);
    setSelectedEndDate(date);
  };

  const handleClickOutside = useCallback((event) => {
    const clickHandlers = [
      {
        selectRef: selectref.current,
        contentRef: divRef.current,
        setOpen: setOpenAdvancedFilter,
      },
      {
        selectRef: selectrefColumn.current,
        contentRef: divRefColumn.current,
        setOpen: setColumnSettings,
      },
    ];
    clickHandlers.forEach(({ selectRef, contentRef, setOpen }) => {
      if (selectRef?.contains(event.target)) return;
      if (contentRef && !contentRef.contains(event.target)) {
        setOpen(false);
      }
    });
  }, []);
  const disableDateRanges = selectedStartDate
    ? [{ start: new Date(0), end: new Date(selectedStartDate - 1) }]
    : [];

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClickOutside]);
  const handleApply = () => {
    // console.log(tempVisibility, "temp-befores");
    // Use setColumnVisibility to update the table's visibility state
    // table.setColumnVisibility(tempVisibility);
    setVisibleColumns(tempVisibility);
    setColumnSettings(false);
  };

  return (
    <div className="flex w-full lg:max-h-14 py-4">
      <div className="flex flex-row justify-between items-center w-full">
        <div>
          <p className="text-[#262626] text-base font-bold">List of Users</p>
        </div>
        <div className="flex flex-row items-center gap-x-4 relative">
          <div className=" relative">
            {" "}
            <button
              ref={selectrefColumn}
              onClick={() => {
                setFilterShow(false);
                setColumnSettings(!columnSettings);
              }}
              className=" p-1 border border-[#DADADA] rounded "
            >
              <TbColumns3 color="#606668" size={17} />
            </button>
            {columnSettings && (
              <div
                ref={divRefColumn}
                className=" absolute bg-white p-3 rounded-lg shadow-lg right-[1px] min-w-[197px] w-fit z-[100]"
              >
                <div className=" w-full flex items-center mb-2">
                  <TbColumns3
                    color="#606668"
                    className="ml-[2px]"
                    width={13}
                    height={11}
                  />
                  <p className=" ml-2 text-[#393939] text-sm font-semibold ">
                    View Column
                  </p>
                </div>
                {leafColumns.map((column) => (
                  <div
                    key={column.id}
                    className=" py-[2px] px-[3.5px] flex items-center h-6"
                  >
                    <input
                      className="  w-[13px] h-[13px]"
                      disabled={column.columnDef.enableHiding === false}
                      type="checkbox"
                      checked={tempVisibility[column.id] ?? true} // Default to visible
                      onChange={() => toggleTempVisibility(column.id)}
                    />{" "}
                    <p className=" ml-[9px] text-[#606668] text-sm font-medium">
                      {convertToTitle(column.id)}{" "}
                    </p>
                  </div>
                ))}
                <div className=" flex justify-between items-center mt-2">
                  <button
                    onClick={() => {
                      setTempVisibility([]);
                      setVisibleColumns([]);
                      setColumnSettings(false);
                    }}
                    className=" w-[82.5px]  h-6 items-center flex justify-center border border-[#00394d] text-[#00394d] font-semibold text-xs rounded"
                  >
                    Reset
                  </button>
                  <button
                    onClick={handleApply}
                    className=" w-[82.5px]  h-6 items-center flex justify-center bg-[#00394d] text-white font-semibold text-xs rounded"
                  >
                    Apply
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="relative">
            <div
              className={` rounded p-1 cursor-pointer text-white flex items-center ${
                filterApplied
                  ? "bg-[#00394D]"
                  : "border-[#DADADA] border border-solid"
              }`}
              ref={selectref}
              onClick={() => {
                setColumnSettings(false);
                setOpenAdvancedFilter(!openAdvancedFilter);
              }}
            >
              <FiFilter
                size={"17px"}
                color={filterApplied ? "#ffffff" : "#656565"}
              />{" "}
              <span className={`${filterApplied && "ml-1"} text-[14px]`}>
                {filterApplied && " ( 1 )"}
              </span>
            </div>
            {openAdvancedFilter && (
              <div
                ref={divRef}
                className=" w-[190px] px-2 rounded-b-lg absolute top-7.5 right-0 z-[100]  bg-white pt-[12px] text-xs font-medium shadow-md pb-2 "
              >
                <p className="text-sm font-bold text-[#262626] mb-2">
                  Filter by
                </p>
                <Select
                  options={options}
                  value={selectedFlag}
                  onChange={(e) => {
                    setSelectedFlag(e);
                    setAdvancedOptionSelected(e?.value);
                  }}
                />
                {advancedOptionSelected === "total_asset_value" ? (
                  <div className="flex flex-col gap-2 mt-2">
                    <Select
                      options={[
                        { value: "less_than", label: "Lesser than" },
                        { value: "greater_than", label: "Greater than" },
                        { value: "equal_to", label: "Equal to" },
                      ]}
                      value={selectedValueFlag}
                      onChange={(e) => {
                        setSelectedValueFlag(e);
                        setAdvancedSelectValue(e?.value);
                      }}
                      placeholder="-Select Value-"
                    />
                    <input
                      type="text"
                      placeholder="-Enter Value-"
                      value={advancedEnterValue}
                      onChange={(e) => setAdvancedEnterValue(e.target.value)}
                      className="w-full text-xs h-8 border border-[#E0E0E0] rounded bg-[#F8F8F8] px-3 py-[14px] mr-1 focus:outline-none placeholder:text-[#848484]"
                      name="value"
                    />
                  </div>
                ) : advancedOptionSelected === "last_login_date" ||
                  advancedOptionSelected === "newest_loan_creation" ? (
                  <div className="flex flex-col gap-2 mt-2">
                    <p className="text-xs font-semibold text-[#262626]">
                      Start date
                    </p>
                    <DatePicker
                      selected={selectedStartDate}
                      onChange={handleStartDateChange}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="w-full h-[45px] text-[13px] py-2 pl-3 rounded border border-solid font-medium placeholder:text-[#848484] placeholder:text-[13px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                    <p className="text-xs font-semibold text-[#262626]">
                      End date
                    </p>
                    <DatePicker
                      selected={selectedEndDate}
                      onChange={handleEndDateChange}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      className="w-full h-[45px] text-[13px] py-2 pl-3 rounded border border-solid font-medium placeholder:text-[#848484] placeholder:text-[13px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                      excludeDateIntervals={disableDateRanges}
                    />
                  </div>
                ) : advancedOptionSelected === "loan_type" ? (
                  <div className="flex flex-col gap-2 mt-2">
                    <Select
                      options={[
                        { value: "overdraft_loan", label: "Overdraft Loan" },
                        { value: "term_loan", label: "Term Loan" },
                      ]}
                      value={loanTypeReference}
                      onChange={(e) => {
                        setLoanTypeReference(e);
                        setLoanType(e?.value);
                      }}
                      placeholder="-Select Value-"
                    />
                  </div>
                ) : advancedOptionSelected === "user_step" ? (
                  <div className="flex flex-col gap-2 mt-2">
                    <Select
                      options={[
                        { value: "Login", label: "Login" },
                        { value: "Pledged", label: "Pledged" },
                        { value: "Bank Details", label: "Bank Details" },
                        { value: "User Kyc", label: "User Kyc" },
                        {
                          value: "Pledged Finished",
                          label: "Pledged Finished",
                        },
                        {
                          value: "Process Completed",
                          label: "Process Completed",
                        },
                        { value: "Withdrawal", label: "Withdrawal" },
                        {
                          value: "Overdraft closed",
                          label: "Overdraft closed",
                        },
                        { value: "Enach", label: "ENACH" },
                      ]}
                      value={userStepReferrence}
                      onChange={(e) => {
                        setUserStepReferrence(e);
                        setUserStepFilter(e?.value);
                      }}
                      placeholder="-Select Value-"
                    />
                  </div>
                ) : (
                  <></>
                )}
                <div className="flex w-full justify-between items-center ">
                  <button
                    type="button"
                    className={` py-[3px] px-2 rounded w-[46%] h-8 font-medium bg-[#00394d] text-white mt-3`}
                    onClick={() => {
                      if (
                        advancedOptionSelected !== "" &&
                        (advancedEnterValue !== "" ||
                          advancedEndDate !== "" ||
                          loanTypeReference !== "" ||
                          userStepReferrence !== "")
                      ) {
                        setFilterApplied(true);
                        const controller = new AbortController();
                        fetchAdvancedFilters(controller);
                      }
                    }}
                  >
                    Filter
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      clearAdvancedFilters();
                      clearFilters();
                    }}
                    className="py-[3px] px-2 rounded w-[46%] h-8 font-medium  text-[#00394d] border border-[#00394d] mt-3"
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}
          </div>
          <form className="">
            <div className="relative w-[70%]">
              <div className="relative w-[210px]">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    dispatch(updateIndividualSearch(e.target.value));
                  }}
                  className="w-full text-xs h-8 border border-[#e0e0e0] rounded bg-[#f8f8f8] px-4 py-[14px] pr-10 focus:outline-none"
                />
                {searchQuery && (
                  <button
                    onClick={() => {
                      setSearchQuery("");
                      dispatch(updateIndividualSearch(""));
                    }}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 focus:outline-none"
                  >
                    <MdOutlineCancel color="#00394d" />
                  </button>
                )}
              </div>
            </div>
          </form>
          {userType !== "distributors" && showButton !== false && (
            <div onClick={() => handlePageDownload()}>
              <FinsireButton text={"Download"} icon={GoDownload} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IndividualsTopBar;
